import React, { useState, useEffect } from 'react';
import { NavLink, unstable_usePrompt as Prompt } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper'; 
import { Box, Typography, Stepper, Step, StepLabel, Accordion, AccordionDetails, AccordionSummary, Button } from '@mui/material'
import Grid from '@mui/material/Grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddPersonalInformation from '../container/AddPersonalInformation';
import AddThirdPartyInformation from '../container/AddThirdPartyInformation';
import AddExportImport from '../container/AddExportImport';
import AddStart from '../container/AddStart';
import AddMonetaryInstrument from '../container/AddMonetaryInstrument'
import AddReviewSign from '../container/AddReviewSign';
import NumberFormat from 'react-number-format';
import RequiredText from './custom/RequiredText';
import Flag from 'react-world-flags'
import Needhelp from '../images/needhelp.jpg'
import AddMailShip from '../container/AddMailShip';
import AddMailShipCT from '../container/AddMailShipCT';
import PersonalInformation from './PersonalInformation';
import ExportImport from './ExportImport';
import ThirdPartyInformation from './ThirdPartyInformation';
import MailShip from './MailShip';
import MailShipCT from './MailShipCT';
import ReviewSign from './ReviewSign';
import Header from '../container/Header';

// function getSteps(start) {
//   if(start.myselfOrSomeone === 'S') {
//     return ['Get Started', 'Personal Information', 'Third Party', 'Origin and Destination', 'Currencies Transported', 'Review and Sign'];
//   } else {
//     return ['Get Started', 'Personal Information', 'Origin and Destination', 'Currencies Transported', 'Review and Sign'];
//   }
// }

function HorizontalStepper(props) {
  const [activeStep, setActiveStep] = useState(props.activeStep);
  const [countThirdParty, setCountThirdParty] = useState(0);
  const [completedStep, setCompletedStep] = useState(0);
  const [formIsHalfFilledOut, setformIsHalfFilledOut] = useState(props.formIsHalfFilledOut);

  const start = props.start; 
  const exportImport = props.exportImport;  
  const currencies = props.currencies;  
  const coins = props.coins;  
  const others = props.others;   

  useEffect(() => {
    document.title = 'Form | FinCEN Form 105 | CMIR, U.S. Customs and Border Protection';
  }, []); // Empty dependency array means it runs once on mount

  useEffect(() => {
    let newCompletedStep
    if (props.activeStep === 0 && props.start.myselfOrSomeone === '') {
      newCompletedStep = 0;
    } else if (completedStep < props.activeStep) {
      newCompletedStep = props.activeStep
    } else {
      newCompletedStep = completedStep
    }
    setActiveStep(props.activeStep)
    setCompletedStep(newCompletedStep)
 },)

  useEffect(() => {
    resetAll;
    // props.formCompleted(true)
  }, [])

  const resetAll = e => {
    props.resetStep();
    props.resetStart();
    props.resetPerson();
    props.resetAddress();
    props.resetExportImport();
    props.resetMailShip();
    props.resetThirdParty();
    props.resetCurrencyItem();
    props.resetCoinItem();
    props.resetOtherItem();
    props.resetReviewSign();
    props.resetReceipt();
  }

  const formCompleted = (status) => {
    setformIsHalfFilledOut(status)
    props.formCompleted(status)
  }
  
  const getSteps = start => {
    const PerBusLabel = start.personalOrBusiness === 'B'? 'Business Information' : 'Personal Information';

    if (start.pct === 'Y') {
      return ['Get Started', PerBusLabel, 'Import and Export', 'Ship and Receive', 'Third Party', 'Monetary Instruments', 'Review and Sign'];
    } else
    if (start.mailingOrPhysical === 'M' && start.myselfOrSomeone === 'S') {
      return ['Get Started', PerBusLabel, 'Ship and Receive', 'Third Party', 'Monetary Instruments', 'Review and Sign'];
    } else 
    if (start.myselfOrSomeone === 'S') {      
      return ['Get Started', PerBusLabel, 'Import and Export', 'Third Party', 'Monetary Instruments', 'Review and Sign'];
    } else 
    if (start.mailingOrPhysical === 'M') {      
      return ['Get Started', PerBusLabel, 'Ship and Receive', 'Monetary Instruments', 'Review and Sign'];
    } else {      
      return ['Get Started', PerBusLabel, 'Import and Export', 'Monetary Instruments', 'Review and Sign'];
    } 
  }

  const handleExpansionChange = panel => (event) => {
    setActiveStep(panel)
    props.updateStep(panel);
  };

  const computeTotal = (currencies, coins, others) => {
    let total = 0;
    currencies.map(currency => {
      return total += Number(Math.round(currency.usdEquivalent))
    })
    coins.map(currency => {
      return total += Number(Math.round(currency.usdEquivalent))
    })
    others.map(currency => {
      return total += Number(Math.round(currency.usdEquivalent))
    })
    return total;
  };

  const steps = getSteps(props.start);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));
    
    return (
      
      <Grid container spacing={0.4} sx={{ flexGrow: 1, justifyContent: 'center' }}>
        <Header />
        <Prompt
          when={formIsHalfFilledOut}              
          message="Are you sure you want to leave? All or part of the entered data might be lost."              
        />
        <Grid container sx={{
          padding: '0px 33px 3px 40px',
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "cover",
          float: 'left',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          direction: 'row',
        }}>
          <Grid container alignItems={"flex-start"} direction={"row"} justifyContent={"flex-start"}>
                  <Grid role="heading" aria-level="4" sx={{
                    color: '#1E1E1E',
                    fontWeight: 'bold',
                    fontSize: { xs: 15, sm: 'inherit' },
                  }} >FinCEN Form 105</Grid>              
                  <Grid role="heading" aria-level="4" sx={{
                    color: '#1E1E1E',
                    fontWeight: 'bold',
                    display: { xs: 'none', sm: 'block' },
                  }} ><span>&nbsp;</span>| Currency and Monetary Instrument Report (CMIR)</Grid>
          </Grid>  
            
          <NavLink to="/help" target="help" rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
            <Grid container sx={{alignItems: "center", justifyContent: "space-between", flexDirection: "row"}}>
              <img src={Needhelp} alt="needhelp" style={{cursor: 'pointer'}}/>
              <Button autoCapitalize="false" sx={{
                marginLeft: '0px',
                fontWeight: 'bold',
                color: '#3440E4',
                textDecoration: 'none',
                textTransform: 'none'
              }} align="center">Need Help?</Button>
            </Grid>
          </NavLink>
      </Grid>

      <center>
        <Grid item xs={10} md={10} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography role="heading" aria-level="2" sx={{
              fontWeight: 'bold',
              margin: '8px 0 12px 0',
              fontSize: {
                xs: '0.875rem',
                sm: '1.125rem',
                md: '1.5rem',
                lg: '1.625rem'
              },
            }}>Report of International Transportation of Currency or Monetary Instruments</Typography>  
        </Grid>

        <Grid item xs={10} md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>      
          <Typography role="heading" aria-level="6" sx={{
            fontWeight: 'bold',
            margin: '12px 0 2px 0',
            fontSize: {
              xs: '0.625rem',
              sm: '0.875rem',
              md: '1rem',
              lg: '1.125rem'
            },
          }}>Please fill out the form below</Typography>
        </Grid>
        
        <Grid item xs={10} md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>      
          <Stepper sx={{ backgroundColor: '#ffffff' }} activeStep={activeStep} alternativeLabel >
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>
                  <Typography sx={{
                    fontWeight: 'bold',
                    fontSize: {
                      xs: '0',
                      sm: '11px',
                      md: '13px',
                      lg: '14px'
                    },
                  }} align='center'>{label}</Typography>
                </StepLabel>               
              </Step>
            ))}
          </Stepper>
        </Grid>
        
      <Grid sx={{
        marginLeft: { xs: '10px', sm: '16px' },
        marginRight: { xs: '10px', sm: 0 },
        maxWidth: { xs: '368px', sm: 'initial' },
      }}>
        <Accordion expanded={activeStep === 0} onChange={handleExpansionChange(0)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{
                color: '#2c387e',
                fontWeight: 'bold',
                fontSize: activeStep === 0 ? '1rem' : '0.9375rem',
              }}>Get Started</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <AddStart formCompleted={formCompleted} />
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={activeStep === 1} disabled={completedStep < 1} onChange={handleExpansionChange(1)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid>
                <Typography sx={{
                  color: '#2c387e',
                  fontWeight: 'bold',
                  fontSize: activeStep === 1 ? '1rem' : '0.9375rem',
                }}>{start.personalOrBusiness === 'B'? 'Business Information' : 'Personal Information'}</Typography>
                {activeStep === 1 && <Typography sx={{
                  fontSize: '0.875rem',
                  fontWeight: 'bold',
                }}>Please enter the Information about the 
                {start.personalOrBusiness === 'B'? ' business ' : ' person '} departing or entering the United States with the currency.</Typography> }
                {activeStep === 1 && <RequiredText/>}
              </Grid>
            </AccordionSummary>
            <AccordionDetails>           
                {/* <AddPersonalInformation /> */}
                <PersonalInformation />
            </AccordionDetails>
          </Accordion>
  
        { (start.pct === 'Y' || start.mailingOrPhysical === 'P' || start.mailingOrPhysical === '') &&      
          <Accordion expanded={activeStep === 2} disabled={completedStep < 2} onChange={handleExpansionChange(2)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>  
              <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ width: '100%' }} >
                <Grid>
                  <Typography sx={{
                    color: '#2c387e',
                    fontWeight: 'bold',
                    fontSize: activeStep === 2 ? '1rem' : '0.9375rem',
                  }}>Import/Export Information</Typography>
                    {activeStep === 2 && <Typography sx={{
                      fontSize: '0.875rem',
                      fontWeight: 'bold',
                    }}>Enter details on how the currency or monetary instrument is being transported.</Typography> }
                    {activeStep === 2 && <RequiredText/>}
                </Grid>
                {start.mailingOrPhysical === 'P' && exportImport.exportOrImport !== -1 &&
                  <Typography sx={{
                    marginLeft: '20px',
                    paddingLeft: '25px',
                    paddingRight: '25px',
                    fontSize: '0.9375rem',
                    textAlign: 'center',
                    color: '#ffffff',
                    backgroundColor: '#4f57ab',
                    fontWeight: 'bold',
                    height: '20px',
                    borderRadius: '1.125rem',
                  }}>
                      {exportImport.exportOrImport === 0? 
                      ['Imported from ', <Flag code={exportImport.departureCountry.value} height="10" />,  exportImport.departureCountry.countryDescription] :  
                      ['Exported to ', <Flag code={exportImport.arriveCountry.value} height="10" />,  exportImport.arriveCountry.countryDescription]}
                  </Typography>
                }
              </Grid> 
            </AccordionSummary>
            <AccordionDetails>
              <ExportImport />
            </AccordionDetails>
          </Accordion>
        }


        { start.mailingOrPhysical === 'M' &&
          <Accordion expanded={activeStep === (start.pct === 'N'? 2 : 3)} disabled={completedStep < (start.pct === 'N'? 2 : 3)} 
                          onChange={handleExpansionChange(start.pct === 'N'? 2 : 3)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>            
              <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} style={{ width: '100%' }}>
                <Grid>
                  <Typography sx={{
                    color: '#2c387e',
                    fontWeight: 'bold',
                    fontSize: activeStep === 3 ? '1rem' : '0.9375rem',
                  }}>Shipping/Receiving Information</Typography>
                    {activeStep === (start.pct === 'N'? 2 : 3) && <Typography sx={{
                      fontSize: '0.875rem',
                      fontWeight: 'bold',
                    }}>Enter details on how the currency or monetary instrument is being transported.</Typography> }
                    {activeStep === (start.pct === 'N'? 2 : 3) && <RequiredText/>}                
                </Grid>
              </Grid>     
            </AccordionSummary>
            <AccordionDetails>
              {/* {console.log("pct in stepper " + JSON.stringify(start.pct))} */}
              {start.pct === 'Y' && <MailShipCT /> } 
              {start.pct === 'N' && <MailShip /> }              
            </AccordionDetails>
          </Accordion>
        }

        { start.myselfOrSomeone === 'S' &&
          <Accordion expanded={activeStep === (start.pct === 'N'? 3 : 4)} disabled={completedStep < (start.pct === 'N'? 3 : 4)} 
                            onChange={handleExpansionChange((start.pct === 'N'? 3 : 4))}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid>
                <Typography sx={{
                  color: '#2c387e',
                  fontWeight: 'bold',
                  fontSize: activeStep === 3 ? '1rem' : '0.9375rem',
                }}>Third Party Information</Typography>
                {activeStep === (start.pct === 'N'? 3 : 4) && <Typography sx={{
                  fontSize: '0.875rem',
                  fontWeight: 'bold',
                }}>Please enter the Information about the Third Party, on behalf of who the Monetary Instrument is transported.</Typography> }
                {activeStep === (start.pct === 'N'? 3 : 4) && <RequiredText/>}
              </Grid>
            
            </AccordionSummary>
            <AccordionDetails>           
                <ThirdPartyInformation />
            </AccordionDetails>
          </Accordion>
        }

          <Accordion expanded={activeStep === (start.pct === 'Y'? 5 : start.myselfOrSomeone === 'S'? 4 : 3)}
              disabled={completedStep < (start.pct === 'Y'? 5 : start.myselfOrSomeone === 'S'? 4 : 3)} 
              onChange={handleExpansionChange(start.pct === 'Y'? 5 : start.myselfOrSomeone === 'S'? 4 : 3)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} style={{ width: '100%' }}>
                <Grid>
                  <Typography sx={{
                    color: '#2c387e',
                    fontWeight: 'bold',
                    fontSize: activeStep === 3 ? '1rem' : '0.9375rem',
                  }}>Monetary Instrument Information</Typography>
                  {activeStep === (start.pct === 'Y'? 5 : start.myselfOrSomeone === 'S'? 4 : 3) && <Typography sx={{
                    fontSize: '0.875rem',
                    fontWeight: 'bold',
                  }}>Type and Amount of Currency or Monetary Instrument being transported.</Typography> }
                  {activeStep === (start.pct === 'Y'? 5 : start.myselfOrSomeone === 'S'? 4 : 3) && <RequiredText/>}
                </Grid>
                {completedStep > (start.pct === 'Y'? 5 : start.myselfOrSomeone === 'S'? 4 : 3) &&              
                <Typography sx={{
                  marginLeft: '20px',
                  paddingLeft: '25px',
                  paddingRight: '25px',
                  fontSize: '0.9375rem',
                  textAlign: 'center',
                  color: '#ffffff',
                  backgroundColor: '#4f57ab',
                  fontWeight: 'bold',
                  height: '20px',
                  borderRadius: '1.125rem',
                }}> 
                  Total: <NumberFormat value={(computeTotal(currencies, coins, others))} isNumericString={true} displayType={'text'} 
                            decimalScale={0} maximumfractiondigits={0} minimumfractiondigits= {0} thousandSeparator={true} prefix={'$'} /> USD
                </Typography> 
                }
              </Grid>      
            </AccordionSummary>
            <AccordionDetails>
                {/* <AddCurrencies /> */}
                <AddMonetaryInstrument />
            </AccordionDetails>
          </Accordion>
       
          <Accordion expanded={activeStep === (start.pct === 'Y'? 6 : start.myselfOrSomeone === 'S'? 5 : 4)} 
                disabled={completedStep < (start.pct === 'Y'? 6 : start.myselfOrSomeone === 'S'? 5 : 4)} 
                onChange={handleExpansionChange(start.pct === 'Y'? 6 : start.myselfOrSomeone === 'S'? 5 : 4)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>            
              <Grid>
                <Typography sx={{
                  color: '#2c387e',
                  fontWeight: 'bold',
                  fontSize: activeStep === (start.pct === 'Y' ? 6 : start.myselfOrSomeone === 'S' ? 5 : 4) ? '1rem' : '0.9375rem',
                }}>Review and Signature</Typography>
                {activeStep === (start.pct === 'Y'? 6 : start.myselfOrSomeone === 'S'? 5 : 4) && <Typography variant='caption'>Review the Summary and complete Signature below.</Typography> }              
              </Grid>     
            </AccordionSummary>
            <AccordionDetails>
                <ReviewSign formCompleted={formCompleted} />
            </AccordionDetails>
          </Accordion>

        </Grid>
        </center>
      </Grid>
    );
  }

export default HorizontalStepper;
